<template>
  <div id="policy-eng">
    <b-row>
      <b-col cols="md-6">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :search-options="{
    enabled: true
  }"
          @on-row-click="onRowClick"
        ></vue-good-table>
      </b-col>
      <b-col cols="md-6">
        <div id="info-box-eng">Click the row to read the clause descriptions.</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "PolicyEng",
  components: {},
  methods: {
    onRowClick(params) {
      // params.row - row object
      // params.pageIndex - index of this row on the current page.
      // params.selected - if selection is enabled this argument
      // indicates selected or not
      // params.event - click event
      console.log(params.row.id);
      var info = document.getElementById("info-box-eng");
      info.innerHTML = "<p><b>" + "Clause No." + params.row.clause + "</b></p>";

      if (params.row.description) {
        // info.innerHTML += "<br>";
        for (var i = 0; i < params.row.description.length; i++) {
          info.innerHTML += "<li>" + params.row.description[i] + "</li>";
        }
      } else {
        // info.innerHTML += "<br>";
        info.innerHTML += "<i>This clause has no descriptions.</i>";
      }

      if (params.row.link) {
        info.innerHTML +=
          '<br> <a target="_blank" href=' +
          params.row.link +
          ">" +
          "Go to reference" +
          "</a>";
      }
    }
  },
  data() {
    return {
      columns: [
        {
          label: "Incident category",
          field: "category"
        },
        {
          label: "Clause no.",
          field: "clause"
        }
      ],
      rows: [
        {
          id: 1,
          category: "Professional Responsibilities to Patients",
          clause: "1-4",
          link:
            "https://www.mchk.org.hk/english/code/files/Code_of_Professional_Conduct_2016.pdf#page=13",
          description: [
            "1.1 Medical records",
            "1.2 Medical examination and subsequent reporting",
            "1.3 Handling of medical records upon transfer or cessation of practice",
            "1.4 Disclosure of medical information to third parties",
            "2.1-2.9 Proper explanation of proposed treatment and risks",
            "2.10 Patients who refuse to listen",
            "2.11 Child patients",
            "2.1.3 Unconscious patients",
            "4.3 Serious infectious diseases"
          ]
        },
        {
          id: 2,
          category: "Communication in Professional Practice",
          clause: "5-8",
          link:
            "https://www.mchk.org.hk/english/code/files/Code_of_Professional_Conduct_2016.pdf#page=22",
          description: [
            "5.1 The need for good communication and accessible information",
            "5.2 Principles and rules of good communication and information dissemination"
          ]
        },
        {
          id: 3,
          category: "Drugs",
          clause: "9-11"
        },
        {
          id: 4,
          category: "Financial Arrangements",
          clause: "12-16",
          link:
            "https://www.mchk.org.hk/english/code/files/Code_of_Professional_Conduct_2016.pdf#page=36",
          description: [
            "13.2 Contract medicine and managed care",
            "15.5 Clinical trials of drugs and appliances"
          ]
        },
        {
          id: 5,
          category: "Relationship with other Practioners and Organizations",
          clause: "17-21"
        },
        {
          id: 6,
          category:
            "New Medical Procedures, Clinical Research and Alternative Medicine",
          clause: "22-24"
        },
        {
          id: 7,
          category: "Abuse of Professional Position",
          clause: "25-26"
        },
        {
          id: 8,
          category: "Criminal Conviction and Disciplinary Proceedings",
          clause: "27-29"
        },
        {
          id: 9,
          category: "Serious Infectious Disease",
          clause: "27-29"
        },
        {
          id: 10,
          category: "Special Areas",
          clause: "33-36"
        }
      ]
    };
  }
};
</script>


<style>
#info-box-eng {
  text-align: left;
}

a:hover {
  text-decoration: none !important;
}
</style>